import React from 'react'
import TreatmentUpdate from '../treatment_components/treatmentUpdate'

export default function Main() {
  return (
    <div className='content-wrapper bg-white p-5' style={{ marginLeft: 0 }}>
      <div>
        <h2>Update Treatment</h2>
        <TreatmentUpdate />
      </div>
    </div>
  )
}
